/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=57f7a64c&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=57f7a64c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\17532\\Desktop\\智慧校园\\school-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f7a64c"]])

export default __exports__